import TourDefinitionForm from "../TourDefinitionForm/TourDefinitionForm";

const AddPackage = () => {
  return (
    <div className="shadow-lg rounded-md overflow-hidden border border-stone-100 bg-white">
      <TourDefinitionForm />
    </div>
  );
};

export default AddPackage;
